export type OutcomeType = 'tp1' | 'tp2' | 'tp3' | 'stop' | 'unknown'

export function normalizeOutcomeType(v: any): OutcomeType {
  const s = String(v || '').trim().toLowerCase()
  if (s === 'entry_missed') return 'tp3'
  if (s === 'tp1' || s === 'tp2' || s === 'tp3' || s === 'stop') return s
  return 'unknown'
}

export function isWinOutcome(t: OutcomeType): boolean {
  return t === 'tp1' || t === 'tp2' || t === 'tp3'
}

export function outcomeLabel(t: OutcomeType): string {
  switch (t) {
    case 'tp3':
      return 'Alvo 3'
    case 'tp2':
      return 'Alvo 2'
    case 'tp1':
      return 'Alvo 1'
    case 'stop':
      return 'Stop'
    default:
      return 'Desconhecido'
  }
}
